import { Dispatch, SetStateAction } from "react";
import EstablishmentUnitForm from "./EstablishmentUnitForm";


const EstablishmentUnitEdit = ({
  nextButtonFunction,
  establishmentID,
  updateInterfaceData,
  setIsEstablishmentUnitInit,
  interfaceData
}: EstablishmentNodeEditProps) => {

  const initialValues: IEstablishmentUnitForm = {
    unitType: interfaceData.unitType,
    unitID: interfaceData.unitID
  }


  const handleSubmit = async (values: IEstablishmentUnitForm) => {
    updateInterfaceData(values);
    setIsEstablishmentUnitInit(true);
    
    nextButtonFunction();
  };
  
  return (
    <>
      
        <EstablishmentUnitForm 
          type={"edit"} 
          initialValues={initialValues} 
          onSubmit={handleSubmit}    
        />
       
    </>
    
  )
}

export default EstablishmentUnitEdit;

type EstablishmentNodeEditProps = {
  nextButtonFunction: () => void;
  setIsEstablishmentUnitInit: Dispatch<SetStateAction<boolean>>;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
  establishmentID?: number;
  interfaceData: IEstablishmentInterfaceForm
}